import React from "react";
import { useLang } from "../context/LanguageContext";

export const StatusPill = ({ status }) => {
  const { t } = useLang();
  const map = {
    live: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    coming: "bg-white/5 text-white/50 border-white/10",
    beta: "bg-gold/15 text-gold border-gold/25",
  };
  const label = { live: t("common.live"), coming: t("common.coming"), beta: t("common.beta") }[status] || status;
  return (
    <span className={`w-fit text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full border ${map[status] || map.coming}`}>
      {label}
    </span>
  );
};

export const Demo = () => {
  const { t } = useLang();
  return <span className="text-[10px] font-semibold uppercase tracking-wider px-1.5 py-0.5 rounded bg-gold/15 text-gold border border-gold/20">{t("common.demo")}</span>;
};

export const Eyebrow = ({ children }) => (
  <div className="text-xs uppercase tracking-[0.2em] text-gold/80">{children}</div>
);
